<ng-container *ngIf="_gridElements && _gridElements?.length > 0 && !(loading$ | async) && !hasError; else infoCard">
    <div class="sh-content-grid-wrapper">
        <sh-table-head
            [availableSelect]="availableSelect"
            [availableActionItems]="!!actionItems"
            [itemsSelectedLabelKey]="itemsSelectedLabelKey"
            [noItemsSelectedLabelKey]="noItemsSelectedLabelKey"
            [canBatchSelect]="canBatchSelect"
            [selectedItemsCount]="selectedItemsCount"
            [selectedPageItemsCount]="selectedPageItems"
            [totalPageItemsCount]="_gridElements.length"
            [isInitialBulk]="isInitialBulk"
            [contextActionGroup]="contextActionGroup"
            (selectionChanged)="onSelectionChanged($event)"
        >
            <ul [ngClass]="activeItem ? 'sh-content-grid--narrow' : 'sh-content-grid'" *ngIf="_gridElements">
                <ng-container [ngSwitch]="gridType">
                    <ng-container *ngSwitchCase="gridTypes.RECORD">
                        <li *ngFor="let gridElement of _gridElements; let i = index; trackBy: trackByFunction" class="sh-content-grid__item">
                            @defer (on viewport; prefetch on idle) {
                                <sh-generic-grid-item
                                    [gridType]="gridType"
                                    [availableSelect]="availableSelect"
                                    [disableSelect]="disableSelect"
                                    [disableSelectMessage]="disableSelectMessage"
                                    [selectionMode]="_selectedElements?.length > 0"
                                    [selected]="isGridItemSelected(gridElement)"
                                    [active]="isGridItemActive(gridElement)"
                                    [item]="gridElement"
                                    [actionGroup]="_gridElementsActionGroups[i]"
                                    [pictureFillMode]="pictureFillMode"
                                    [isClickable]="areItemsClickable"
                                    (selectItem)="selectGridItem(gridElement, $event)"
                                    (clickItem)="clickGridItem(gridElement)"
                                    (clickOverlay)="clickGridItemOverlay(gridElement)"
                                ></sh-generic-grid-item>
                            } @placeholder {
                                <div class="grid-item-placeholder"></div>
                            }
                        </li>
                    </ng-container>
                    <ng-container *ngSwitchDefault>
                        <li *ngFor="let gridElement of _gridElements; let i = index; trackBy: trackByFunction" class="sh-content-grid__item">
                            @defer (on viewport; prefetch on idle) {
                                <sh-generic-grid-item
                                    [gridType]="gridType"
                                    [availableSelect]="availableSelect"
                                    [selectionMode]="_selectedElements?.length > 0"
                                    [selected]="isGridItemSelected(gridElement)"
                                    [active]="isGridItemActive(gridElement)"
                                    [item]="gridElement"
                                    [isClickable]="areItemsClickable"
                                    (selectItem)="selectGridItem(gridElement, $event)"
                                    (clickItem)="clickGridItem(gridElement)"
                                    (clickOverlay)="clickGridItemOverlay(gridElement)"
                                ></sh-generic-grid-item>
                            } @placeholder {
                                <div class="grid-item-placeholder"></div>
                            }
                        </li>
                    </ng-container>
                </ng-container>
            </ul>
        </sh-table-head>
    </div>
</ng-container>

<ng-template #infoCard>
    <div class="sh-card-table-wrapper">
        <table class="sh-card-table">
            <thead>
                <th scope="col"></th>
            </thead>
            <tbody>
                <tr id="generic-grid-loading-row" *ngIf="loading$ | async">
                    <td style="width: 2000vw">{{ loadingMsg }}</td>
                </tr>

                <tr id="generic-grid-error-row" *ngIf="hasError && !(loading$ | async)" class="sh-card-table__row--error">
                    <td style="width: 2000vw">{{ loadingFailedMsg }}</td>
                </tr>

                <tr *ngIf="!hasError && _gridElements && _gridElements?.length === 0 && !(loading$ | async)" class="sh-card-table__row--update">
                    <td style="width: 2000vw">{{ emptyListMsg }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</ng-template>
